import React from "react";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Partners from "../components/Partners_logo";
import ProductTabs from "../components/ProductTabs";
import Careers from "../components/Careers";
import Events from "../components/Events";
import StatsSection from "../components/StatsSection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <main className="homepage">
      <Topbar />
      <Navbar />
      <Hero />
      <About />
      <Partners />
      <ProductTabs />
      <Careers />
      <Events />
      <StatsSection />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
